import createTransactionsAPI from "@/helpers/rtk_transactions_resource_factory";
import { getCurrentUser } from "@/helpers/session_helper";

const baseURL = process.env.REACT_APP_GLOBO_API + "/transactions/patientEnrollments";
const type = "PatientEnrollments";
const currentUser = getCurrentUser()

export const patientEnrollmentsAPI = createTransactionsAPI({
  baseURL: baseURL,
  resource: "PatientEnrollments",
  tagTypes: ["PatientEnrollments"],
  idKey: "patientEnrollmentId",
  lookupMap: ({ patientEnrollmentId, referenceNo }) => ({
    value: patientEnrollmentId,
    label: referenceNo,
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListPatientEnrollmentsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      },
    }),
    getFilesPatientEnrollments: query(`${baseURL}/files/list`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) =>
        result?.success
          ? [...(result?.items || result?.returnData)?.map((item) => ({ type: type, id: item[idKey] })), { type: type, id: type }]
          : [{ type: type, id: type }],
    }),
  }),
  customMutations: (mutation, mutationOptions,builder) => ({
    submitPatientEnrollments: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnPatientEnrollments: mutation(`${baseURL}/return`, mutationOptions("save")),
    approvePatientEnrollments: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectPatientEnrollments: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelPatientEnrollments: mutation(`${baseURL}/cancel`, mutationOptions("save")),
    filesUploadPatientEnrollments: mutation(`${baseURL}/files/upload`),
    filesDeletePatientEnrollments: mutation(`${baseURL}/files/delete`),
    sendEmailPatientEnrollments: mutation(`${baseURL}/send-email`),
    exportListForViewerPatientEnrollments: builder.mutation({
      query: (params) => ({
        url: `${baseURL}/exportListForViewer`,
        method: "POST",
        body: params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${currentUser?.token}`,
        },
      }),
      async onQueryStarted(params, { queryFulfilled }) {
        try {
          const response = await fetch(`${baseURL}/exportListForViewer`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${currentUser?.token}`,
            },
            body: JSON.stringify(params),
          });

          if (!response.ok) throw new Error("Export failed");

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `PatientEnrollments-Viewer-${new Date().toISOString().split("T")[0]}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          await queryFulfilled.catch(() => { });
        } catch (err) {
          console.error("Export failed:", err);
          throw err;
        }
      },
    }),
  }),
});

export const {
  useGetPatientEnrollmentsQuery,
  useGetListPatientEnrollmentsForViewersQuery,
  useExportPatientEnrollmentsMutation,
  useFindPatientEnrollmentsQuery,
  useLookUpPatientEnrollmentsMutation,
  useSavePatientEnrollmentsMutation,
  useSubmitPatientEnrollmentsMutation,
  useReturnPatientEnrollmentsMutation,
  useApprovePatientEnrollmentsMutation,
  useRejectPatientEnrollmentsMutation,
  useCancelPatientEnrollmentsMutation,
  useDeletePatientEnrollmentsMutation,
  useFilesUploadPatientEnrollmentsMutation,
  useFilesDeletePatientEnrollmentsMutation,
  useGetFilesPatientEnrollmentsQuery,
  useExportListForViewerPatientEnrollmentsMutation,
  useSendEmailPatientEnrollmentsMutation,
} = patientEnrollmentsAPI;
